import {
  Box,
  Button,
  FormControlLabel,
  Grid,
  MenuItem,
  Pagination,
  Paper,
  Select,
  Switch,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableRow,
  Typography,
} from '@mui/material';
import React, { useEffect } from 'react';
import { useState } from 'react';
import { useReportPageStyles } from './styles';
import { COLORS } from '../../../utils/colors';
import {
  BorderColor,
  CalendarMonth,
  Check,
  ChevronLeft,
  ChevronRight,
  Description,
  Edit,
  PendingOutlined,
  Tune,
} from '@mui/icons-material';
import UnfoldMoreIcon from '@mui/icons-material/UnfoldMore';
import RemoveRedEyeOutlinedIcon from '@mui/icons-material/RemoveRedEyeOutlined';
import CustomLoadingBar from '../../../components/CustomLoadingBar/CustomLoadingBar';
import ArrowDropUpIcon from '@mui/icons-material/ArrowDropUp';
import ArrowDropDownIcon from '@mui/icons-material/ArrowDropDown';
import ReportFiltersModal from '../ReportsFiltersModal';
import { CalendarEvent } from '../../../global/interfaces';
import { format } from 'date-fns';
import CalendarSideMenu from '../CalendarSchedule/CalendarSideMenu';
import { useBookingsContext } from '../../../contexts/BookingsContext';
import { NavigateAction } from 'react-big-calendar';
import { useScheduleCalendarStyles } from '../CalendarSchedule/styles';

const sessions = {
  'Wed 11': [
    {
      title: 'Quarterly Property Assessment',
      sessionType: 'Home Health Check',
      sessionProgress: 'Report Sent',
    },
  ],
  'Thurs 12': [
    {
      title: 'Post-Storm Roof Inspection',
      sessionType: 'Seasonal Service',
      sessionProgress: 'Pending Report',
    },
    {
      title: 'Smart Home Device Setup',
      sessionType: 'Installation Support',
      sessionProgress: 'Report Sent',
    },
  ],
  'Fri 13': [
    {
      title: 'Energy Efficiency Evaluation',
      sessionType: 'Green Initiatives',
      sessionProgress: 'Scheduled',
    },
    {
      title: 'Emergency Heating Repair',
      sessionType: 'Problem Solver',
      sessionProgress: 'Completed',
    },
  ],
  'Sat 14': [
    {
      title: 'Water Quality Testing',
      sessionType: 'Health & Safety',
      sessionProgress: 'Report in Progress',
    },
  ],
  'Sun 15': [
    {
      title: 'Roofing Issue Assessment',
      sessionType: 'Problem Solver',
      sessionProgress: 'Pending Report',
    },
    {
      title: 'Electrical Safety Check',
      sessionType: 'Home Health Check',
      sessionProgress: 'Scheduled',
    },
  ],
  'Mon 16': [
    {
      title: 'Winter HVAC Inspection',
      sessionType: 'Seasonal Service',
      sessionProgress: 'Scheduled',
    },
    {
      title: 'Appliance Installation Follow-Up',
      sessionType: 'Installation Support',
      sessionProgress: 'Completed',
    },
  ],
  'Tues 17': [
    {
      title: 'New Client Onboarding',
      sessionType: 'Home 101',
      sessionProgress: 'Report Sent',
    },
  ],
  'Wed 18': [
    {
      title: 'Monthly Home Maintenance Check',
      sessionType: 'Home Health Check',
      sessionProgress: 'Report in Progress',
    },
    {
      title: 'Emergency Plumbing Repair',
      sessionType: 'Problem Solver',
      sessionProgress: 'Report Sent',
    },
  ],
};

const Reports = () => {
  const periodViews = [
    'All Sessions',
    'Report in Progress',
    'Completed',
    'Report Sent',
  ];

  const [periodView, setPeriodView] = useState('All Sessions');
  const [navigation, setNavigation] = useState('De');
  const { toolbarLabel, setToolbarLabel, handleToolbarNavigate } =
    useBookingsContext();
  // const [data, setData] = useState(items);
  const [sortConfig, setSortConfig] = useState({ key: '', direction: 'asc' });

  const styles = useReportPageStyles();
  const calendarStyles = useScheduleCalendarStyles();
  const [filteredData, setFilteredData] = useState(sessions);
  const [selectedValue, setSelectedValue] = useState('');

  const handleValueChange = (event: any) => {
    setSelectedValue(event.target.value);
  };

  const getLabelForDate = (date?: Date) => {
    if (!date) return '';
    const options: Intl.DateTimeFormatOptions = {
      month: 'long',
      year: 'numeric',
    };
    return new Intl.DateTimeFormat('en-US', options).format(date);
  };

  useEffect(() => {
    if (!toolbarLabel) {
      setToolbarLabel(getLabelForDate(new Date()));
    }
  }, []);

  // const handleSort = (key: string) => {
  //   let direction = 'asc';
  //   if (sortConfig.key === key && sortConfig.direction === 'asc') {
  //     direction = 'desc';
  //   }
  //   setSortConfig({ key, direction });

  //   const sortedItems = [...items].sort((a: any, b: any) => {
  //     const valueA = a[key] ?? '';
  //     const valueB = b[key] ?? '';

  //     const itemA = typeof valueA === 'string' ? valueA.toLowerCase() : valueA;
  //     const itemB = typeof valueB === 'string' ? valueB.toLowerCase() : valueB;

  //     if (itemA < itemB) return direction === 'asc' ? -1 : 1;
  //     if (itemA > itemB) return direction === 'asc' ? 1 : -1;
  //     return 0;
  //   });

  //   setData(sortedItems);
  // };

  // const getStatusColor = (status: string) => {
  //   switch (status) {
  //     case 'Generating...':
  //       return 'black';
  //     case 'Sent':
  //       return 'green';
  //     case 'Past Due':
  //       return 'red';
  //     case 'Ready for Review':
  //       return 'blue';
  //     default:
  //       return 'gray';
  //   }
  // };

  useEffect(() => {
    const filterSessions = () => {
      if (periodView === 'All Sessions') {
        return sessions;
      }

      return Object.entries(sessions).reduce(
        (acc: any, [date, daySessions]) => {
          const matchingSessions = daySessions.filter(
            (session) => session.sessionProgress === periodView,
          );
          if (matchingSessions.length > 0) {
            acc[date] = matchingSessions;
          }
          return acc;
        },
        {} as typeof sessions,
      );
    };

    setFilteredData(filterSessions());
  }, [periodView]);

  // const startIndex = (currentPage - 1) * itemsPerPage;
  // const endIndex = startIndex + itemsPerPage;
  // const paginatedData = filteredData.slice(startIndex, endIndex);

  // const pageCount = Math.ceil(filteredData.length / itemsPerPage);
  const { filters, setFilters } = useBookingsContext();
  const [selectedDate, setSelectedDate] = useState<Date>(new Date());
  return (
    <>
      <Box display={'flex'} sx={{ minHeight: '92vh' }}>
        <CalendarSideMenu
          isReportsPage={true}
          setOpenFilters={() => false}
          openFilters={false}
          filters={filters}
          setFilters={setFilters}
          currentDate={selectedDate}
          setCurrentDate={setSelectedDate}
          setCalView={() => false}
        />
        <Box width={'100%'}>
          <Box width={'100%'} sx={styles.header}>
            <Box
              sx={{
                ...calendarStyles.reportsContainer,
                display: 'block',
                marginLeft: '0px',
                paddingTop: '0px',
              }}>
              <Box
                width={'100%'}
                display={'flex'}
                justifyContent={'space-between'}
                alignItems={'center'}>
                <Box display={'flex'} alignItems={'center'}>
                  <Button
                    onClick={() => handleToolbarNavigate('PREV')}
                    sx={{
                      minWidth: '1rem',
                      color: COLORS.DARK_GREY,
                      height: '2rem',
                    }}>
                    <ChevronLeft />
                  </Button>
                  <Button
                    onClick={() => handleToolbarNavigate('NEXT')}
                    sx={{
                      minWidth: '1rem',
                      color: COLORS.DARK_GREY,
                      height: '2rem',
                    }}>
                    <ChevronRight />
                  </Button>
                  <Typography
                    sx={calendarStyles.navigationTitle}
                    margin={'1.375rem 1.813rem'}>
                    {toolbarLabel}
                  </Typography>
                </Box>
                <Box
                  display={'flex'}
                  alignItems={'center'}
                  justifyContent={'flex-end'}>
                  <Select
                    displayEmpty
                    label={'Month'}
                    size="small"
                    sx={{
                      borderRadius: '3rem',
                      minWidth: '10rem',
                      '.MuiOutlinedInput-notchedOutline': {
                        border: '1px solid #464e5f',
                      },
                    }}
                    defaultValue="All Sessions"
                    value={periodView}
                    onChange={(e) => setPeriodView(e.target.value)}>
                    {periodViews.map((view) => (
                      <MenuItem value={view}>{view}</MenuItem>
                    ))}
                  </Select>
                </Box>
              </Box>

              {/* <Box display={'flex'} justifyContent={'space-between'}>
            <Box
              display="flex"
              justifyContent="flex-start"
              alignItems="center"
              mt={4}
              ml={2}>
              <Typography>
                Showing {startIndex + 1}-{endIndex} of {filteredData.length}
              </Typography>
            </Box>
            <Box
              display="flex"
              justifyContent="flex-end"
              alignItems={'flex-end'}>
              <Pagination
                count={pageCount}
                page={currentPage}
                onChange={(event, value) => setCurrentPage(value)}
              />
            </Box>
          </Box> */}

              <Box
                sx={{
                  border: 'solid 1px #e6e6e6',
                  borderRadius: '0.35rem',
                  overflowY: 'auto',
                  maxHeight: '80vh',
                }}>
                <TableContainer>
                  <Table>
                    <TableBody
                      sx={{
                        border: 'solid 1px #e6e6e6',
                        borderRadius: '1rem',
                      }}>
                      {Object.entries(filteredData).map(
                        ([day, daySessions]) => (
                          <React.Fragment key={day}>
                            {daySessions.map((session, index) => (
                              <TableRow
                                key={`${day}-${index}`}
                                sx={{
                                  '&:hover': {
                                    backgroundColor: '#ebebeb',
                                  },
                                }}>
                                {index === 0 && (
                                  <TableCell
                                    rowSpan={daySessions.length}
                                    align="center"
                                    sx={{
                                      width: '20%',
                                      fontSize: '1rem',
                                      verticalAlign: 'top',
                                      color: '#464e5f',
                                      backgroundColor: '#fff',
                                    }}>
                                    {day}
                                  </TableCell>
                                )}

                                <TableCell
                                  align="left"
                                  valign="middle"
                                  sx={{
                                    width: '40%',
                                    borderBottom: 'solid 1px #e6e6e6',
                                    verticalAlign: 'middle',
                                  }}>
                                  <Box
                                    display="flex"
                                    alignItems="center"
                                    gap={1}>
                                    {session.sessionProgress !==
                                    ('Complete' && 'Report Sent') ? (
                                      <PendingOutlined />
                                    ) : (
                                      <Check sx={{ color: '#17c837' }} />
                                    )}
                                    <span>{session.title}</span>
                                  </Box>
                                </TableCell>

                                <TableCell
                                  align="left"
                                  sx={{
                                    width: '20%',
                                    borderBottom: 'solid 1px #e6e6e6',
                                  }}>
                                  {session.sessionType}
                                </TableCell>
                                <TableCell
                                  align="left"
                                  sx={{
                                    width: '20%',
                                    borderBottom: 'solid 1px #e6e6e6',
                                  }}>
                                  {session.sessionProgress}
                                </TableCell>
                              </TableRow>
                            ))}
                          </React.Fragment>
                        ),
                      )}
                    </TableBody>
                  </Table>
                </TableContainer>
              </Box>
            </Box>
          </Box>
        </Box>
      </Box>
      {/* <ReportFiltersModal
        open={openFilters}
        onClose={() => setOpenFilters(false)}
      /> */}
    </>
  );
};

export default Reports;
